import React from "react";
import ReactDOM from "react-dom";

import LatestNewsService from "services/LatestNewsService";

import LocalNews from "./LocalNews";
import LocalNewsBlock from "./LocalNewsBlock";

const localNewsSettings = {
  title: "Nieuws uit:",
  dropdownPrefix: "—  Nieuws in jouw gemeente?",
  dropdownText: "Kies een gemeente",
};

const localNewsContainers = document.querySelectorAll("[data-local-news]");
[...localNewsContainers].forEach((localNewsContainer) => {
  ReactDOM.render(
    <LocalNews settings={localNewsSettings} />,
    localNewsContainer
  );
});

const localNewsBlockContainers = document.querySelectorAll(
  "[data-local-news-block]"
);
[...localNewsBlockContainers].forEach((localNewsBlockContainer) => {
  ReactDOM.render(
    <LocalNewsBlock settings={localNewsSettings} service={LatestNewsService} />,
    localNewsBlockContainer
  );
});
